import { ApiError } from '@/lib/api/client';
import type { EmailLocale, EmailTemplateContent } from '@/lib/api/types';

export const EMAIL_LOCALES: EmailLocale[] = ['ru', 'uz', 'en'];
export const LOCALE_LABEL: Record<EmailLocale, string> = { ru: 'Русский', uz: 'Oʻzbekcha', en: 'English' };
export const GROUP_LABEL: Record<string, string> = { auth: 'Вход и доступ', guest: 'Гостям', billing: 'Биллинг', broadcast: 'Рассылки', hotel: 'Отелям' };
export const FIELD_LABEL: Record<keyof EmailTemplateContent, string> = {
  subject: 'Тема', heading: 'Заголовок', bodyMd: 'Текст', actionLabel: 'Кнопка', notesMd: 'Мелкий шрифт',
};
const FIELDS = Object.keys(FIELD_LABEL) as Array<keyof EmailTemplateContent>;

/** Put `insert` in place of the selection `start..end`; the caret lands after it. */
export function insertAt(value: string, start: number, end: number, insert: string): { value: string; caret: number } {
  return { value: value.slice(0, start) + insert + value.slice(end), caret: start + insert.length };
}

export function sameContent(a: EmailTemplateContent, b: EmailTemplateContent): boolean {
  return FIELDS.every((f) => a[f] === b[f]);
}

const PROBLEM: Record<string, (variable?: string) => string> = {
  Required: () => 'Обязательное поле',
  TooLong: () => 'Слишком длинно',
  UnknownVariable: (v) => `Нет такой переменной: {{${v ?? ''}}}`,
  MalformedVariable: () => 'Незакрытые скобки {{ }}',
  OptionalVariableInSubject: (v) => `{{${v ?? ''}}} может быть пустой — в теме и заголовке нельзя`,
  UnsafeLink: (v) => `Ссылки только http(s) и mailto: ${v ?? ''}`,
  VariableInLink: () => 'Переменная не может стоять в адресе ссылки — только в её тексте',
};

/** A template 422 from the backend as "which field, what to tell the person"; anything else → null. */
export function templateError(err: unknown): { field: keyof EmailTemplateContent; message: string } | null {
  if (!ApiError.is(err) || err.statusCode !== 422) return null;
  const field = err.details?.field;
  const text = PROBLEM[err.error];
  if (typeof field !== 'string' || !FIELDS.includes(field as keyof EmailTemplateContent) || !text) return null;
  const variable = typeof err.details?.variable === 'string' ? err.details.variable : undefined;
  return { field: field as keyof EmailTemplateContent, message: text(variable) };
}
